import service from '@/api/newsletter/email';
import {handleError} from '@/state/generators/helpers';
import {alert, changes, loading} from "../../generators/helpers";

export const state = {
    emailListId: null,
    item: {},
    service: service('newsletters/emails'),

    openersLoading: false,
    openersPager: {},
    openersAdditional: {},
    openersList: [],

    deliveriesLoading: false,
    deliveriesPager: {},
    deliveriesAdditional: {},
    deliveriesList: [],

    failsLoading: false,
    failsPager: {},
    failsAdditional: {},
    failsList: [],

    blacklistedLoading: false,
    blacklistedPager: {},
    blacklistedAdditional: {},
    blacklistedList: [],

    unsubscribedLoading: false,
    unsubscribedPager: {},
    unsubscribedAdditional: {},
    unsubscribedList: [],

    waitingForSendingLoading: false,
    waitingForSendingPager: {},
    waitingForSendingAdditional: {},
    waitingForSendingList: [],

    relatedToNewsletterLoading: false,
    relatedToNewsletterPager: {},
    relatedToNewsletterAdditional: {},
    relatedToNewsletterList: [],

    fieldsLoading: false,
    fields: [],

    fieldsAutocompleteLoading: false,
    fieldsAutocomplete: [],
}

export const getters = {
    openersLoading: function (state) {
        return !!state.openersLoading
    },
    openersPager: function (state) {
        return JSON.parse(JSON.stringify(state.openersPager))
    },
    openers: function (state) {
        return state.openersList
    },
    openersAdditional: function (state) {
        return JSON.parse(JSON.stringify(state.openersAdditional))
    },
    deliveriesLoading: function (state) {
        return !!state.deliveriesLoading
    },
    deliveriesPager: function (state) {
        return JSON.parse(JSON.stringify(state.deliveriesPager))
    },
    deliveries: function (state) {
        return state.deliveriesList
    },
    deliveriesAdditional: function (state) {
        return JSON.parse(JSON.stringify(state.deliveriesAdditional))
    },
    failsLoading: function (state) {
        return !!state.failsLoading
    },
    failsPager: function (state) {
        return JSON.parse(JSON.stringify(state.failsPager))
    },
    fails: function (state) {
        return state.failsList
    },
    failsAdditional: function (state) {
        return JSON.parse(JSON.stringify(state.failsAdditional))
    },
    blacklistedLoading: function (state) {
        return !!state.blacklistedLoading
    },
    blacklistedPager: function (state) {
        return JSON.parse(JSON.stringify(state.blacklistedPager))
    },
    blacklisted: function (state) {
        return state.blacklistedList
    },
    blacklistedAdditional: function (state) {
        return JSON.parse(JSON.stringify(state.blacklistedAdditional))
    },
    unsubscribedLoading: function (state) {
        return !!state.unsubscribedLoading
    },
    unsubscribedPager: function (state) {
        return JSON.parse(JSON.stringify(state.unsubscribedPager))
    },
    unsubscribed: function (state) {
        return state.unsubscribedList
    },
    unsubscribedAdditional: function (state) {
        return JSON.parse(JSON.stringify(state.unsubscribedAdditional))
    },
    waitingForSendingLoading: function (state) {
        return !!state.waitingForSendingLoading
    },
    waitingForSendingPager: function (state) {
        return JSON.parse(JSON.stringify(state.waitingForSendingPager))
    },
    waitingForSending: function (state) {
        return state.waitingForSendingList
    },
    waitingForSendingAdditional: function (state) {
        return JSON.parse(JSON.stringify(state.waitingForSendingAdditional))
    },
    relatedToNewsletterLoading: function (state) {
        return !!state.relatedToNewsletterLoading
    },
    relatedToNewsletterPager: function (state) {
        return JSON.parse(JSON.stringify(state.relatedToNewsletterPager))
    },
    relatedToNewsletter: function (state) {
        return state.relatedToNewsletterList
    },
    relatedToNewsletterAdditional: function (state) {
        return JSON.parse(JSON.stringify(state.relatedToNewsletterAdditional))
    },
    fields: function (state) {
        return JSON.parse(JSON.stringify(state.fields))
    },
    fieldsLoading: function (state) {
        return !!state.fieldsLoading
    },
    fieldsAutocomplete: function (state) {
        return JSON.parse(JSON.stringify(state.fieldsAutocomplete))
    },
    fieldsAutocompleteLoading: function (state) {
        return !!state.fieldsAutocompleteLoading
    },
}

export const mutations = {
    'SET_EMAIL_LIST_ID': function (state, emailListId = null) {
        state.emailListId = emailListId;
    },

    'SET_OPENERS_LOADING': function (state, boolean = true) {
        state.openersLoading = boolean;
    },

    'SET_OPENERS_LIST': function (state, list) {
        state.openersList = list;
    },

    'SET_OPENERS_PAGER': function (state, pager = {}) {
        state.openersPager = pager;
    },

    'SET_OPENERS_ADDITIONAL': function (state, data = {}) {
        state.openersAdditional = data;
    },

    'SET_DELIVERIES_LOADING': function (state, boolean = true) {
        state.deliveriesLoading = boolean;
    },

    'SET_DELIVERIES_LIST': function (state, list) {
        state.deliveriesList = list;
    },

    'SET_DELIVERIES_PAGER': function (state, pager = {}) {
        state.deliveriesPager = pager;
    },

    'SET_DELIVERIES_ADDITIONAL': function (state, data = {}) {
        state.deliveriesAdditional = data;
    },

    'SET_FAILS_LOADING': function (state, boolean = true) {
        state.failsLoading = boolean;
    },

    'SET_FAILS_LIST': function (state, list) {
        state.failsList = list;
    },

    'SET_FAILS_PAGER': function (state, pager = {}) {
        state.failsPager = pager;
    },

    'SET_FAILS_ADDITIONAL': function (state, data = {}) {
        state.failsAdditional = data;
    },

    'SET_BLACKLISTED_LOADING': function (state, boolean = true) {
        state.blacklistedLoading = boolean;
    },

    'SET_BLACKLISTED_LIST': function (state, list) {
        state.blacklistedList = list;
    },

    'SET_BLACKLISTED_PAGER': function (state, pager = {}) {
        state.blacklistedPager = pager;
    },

    'SET_BLACKLISTED_ADDITIONAL': function (state, data = {}) {
        state.blacklistedAdditional = data;
    },

    'SET_UNSUBSCRIBED_LOADING': function (state, boolean = true) {
        state.unsubscribedLoading = boolean;
    },

    'SET_UNSUBSCRIBED_LIST': function (state, list) {
        state.unsubscribedList = list;
    },

    'SET_UNSUBSCRIBED_PAGER': function (state, pager = {}) {
        state.unsubscribedPager = pager;
    },

    'SET_UNSUBSCRIBED_ADDITIONAL': function (state, data = {}) {
        state.unsubscribedAdditional = data;
    },

    'SET_WAITING_FOR_SENDING_LOADING': function (state, boolean = true) {
        state.waitingForSendingLoading = boolean;
    },

    'SET_WAITING_FOR_SENDING_LIST': function (state, list) {
        state.waitingForSendingList = list;
    },

    'SET_WAITING_FOR_SENDING_PAGER': function (state, pager = {}) {
        state.waitingForSendingPager = pager;
    },

    'SET_WAITING_FOR_SENDING_ADDITIONAL': function (state, data = {}) {
        state.waitingForSendingAdditional = data;
    },

    'SET_RELATED_TO_NEWSLETTER_LOADING': function (state, boolean = true) {
        state.relatedToNewsletterLoading = boolean;
    },

    'SET_RELATED_TO_NEWSLETTER_LIST': function (state, list) {
        state.relatedToNewsletterList = list;
    },

    'SET_RELATED_TO_NEWSLETTER_PAGER': function (state, pager = {}) {
        state.relatedToNewsletterPager = pager;
    },

    'SET_RELATED_TO_NEWSLETTER_ADDITIONAL': function (state, data = {}) {
        state.relatedToNewsletterAdditional = data;
    },

    'SET_FIELDS_LOADING': function (state, boolean = true) {
        state.fieldsLoading = boolean;
    },

    'SET_FIELDS': function (state, list) {
        state.fields = list;
    },

    'SET_FIELDS_AUTOCOMPLETE_LOADING': function (state, boolean = true) {
        state.fieldsAutocompleteLoading = boolean;
    },

    'SET_FIELDS_AUTOCOMPLETE': function (state, list) {
        state.fieldsAutocomplete = list;
    },
}
export const actions = {
    setEmailListId: function ({ commit }, emailListId) {
        commit('SET_EMAIL_LIST_ID', emailListId);
    },

    create: function ({commit, state}, payload) {
        loading(commit);

        if (state.emailListId) {
            payload.email_list_id = state.emailListId;
        }

        return state.service.store(payload).then(data => {
            const model = Object.assign({}, payload, data.data)

            commit('ADD_ITEM', model);
            commit('SET_ITEM', model);
            alert(commit, this.$t('request.creation_is_successful'));
            commit('SET_ERRORS', {});
            // dispatch('all', state.allQuery);

            loading(commit, false)

            return model
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    update: function ({commit, state}, payload) {
        loading(commit)

        const { id, data } = changes(payload, state.item)

        if (state.emailListId) {
            data.email_list_id = state.emailListId;
        }

        const content = Object.assign({_method: 'PUT'}, data)

        return state.service.update(id, content).then(response => {
            const model = Object.assign({}, data, response.data)

            commit('REPLACE_ITEM', model);
            commit('SET_ITEM', model);
            alert(commit, this.$t('request.save_is_successful'))
            commit('SET_ERRORS', {});
            loading(commit, false)

            return model;
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    openers: function ({commit, state}, filters) {
        commit('SET_OPENERS_LOADING');

        return state.service.openers(filters.id, filters).then(response => {
            commit('SET_OPENERS_LIST', response.data)
            commit('SET_OPENERS_PAGER', response.meta)
            commit('SET_OPENERS_ADDITIONAL', response.additional)
            commit('SET_OPENERS_LOADING', false);
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    deliveries: function ({commit, state}, filters) {
        commit('SET_DELIVERIES_LOADING');

        return state.service.deliveries(filters.id, filters).then(response => {
            commit('SET_DELIVERIES_LIST', response.data)
            commit('SET_DELIVERIES_PAGER', response.meta)
            commit('SET_DELIVERIES_ADDITIONAL', response.additional)
            commit('SET_DELIVERIES_LOADING', false);
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    fails: function ({commit, state}, filters) {
        commit('SET_FAILS_LOADING');

        return state.service.fails(filters.id, filters).then(response => {
            commit('SET_FAILS_LIST', response.data)
            commit('SET_FAILS_PAGER', response.meta)
            commit('SET_FAILS_ADDITIONAL', response.additional)
            commit('SET_FAILS_LOADING', false);
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    blacklisted: function ({commit, state}, filters) {
        commit('SET_BLACKLISTED_LOADING');

        return state.service.blacklisted(filters.id, filters).then(response => {
            commit('SET_BLACKLISTED_LIST', response.data)
            commit('SET_BLACKLISTED_PAGER', response.meta)
            commit('SET_BLACKLISTED_ADDITIONAL', response.additional)
            commit('SET_BLACKLISTED_LOADING', false);
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    unsubscribed: function ({commit, state}, filters) {
        commit('SET_UNSUBSCRIBED_LOADING');

        return state.service.unsubscribed(filters.id, filters).then(response => {
            commit('SET_UNSUBSCRIBED_LIST', response.data)
            commit('SET_UNSUBSCRIBED_PAGER', response.meta)
            commit('SET_UNSUBSCRIBED_ADDITIONAL', response.additional)
            commit('SET_UNSUBSCRIBED_LOADING', false);
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    waitingForSending: function ({commit, state}, filters) {
        commit('SET_WAITING_FOR_SENDING_LOADING');

        return state.service.waitingForSending(filters.id, filters).then(response => {
            commit('SET_WAITING_FOR_SENDING_LIST', response.data)
            commit('SET_WAITING_FOR_SENDING_PAGER', response.meta)
            commit('SET_WAITING_FOR_SENDING_ADDITIONAL', response.additional)
            commit('SET_WAITING_FOR_SENDING_LOADING', false);
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    relatedToNewsletter: function ({commit, state}, filters) {
        commit('SET_RELATED_TO_NEWSLETTER_LOADING');

        return state.service.relatedToNewsletter(filters.id, filters).then(response => {
            commit('SET_RELATED_TO_NEWSLETTER_LIST', response.data)
            commit('SET_RELATED_TO_NEWSLETTER_PAGER', response.meta)
            commit('SET_RELATED_TO_NEWSLETTER_ADDITIONAL', response.additional)
            commit('SET_RELATED_TO_NEWSLETTER_LOADING', false);
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    fields: function ({commit, state, getters}) {
        if (state.fields.length) {
            return getters.fields;
        }

        commit('SET_FIELDS_LOADING');

        return state.service.fields().then(response => {
            commit('SET_FIELDS', response.data);
            commit('SET_FIELDS_LOADING', false);
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    autocomplete: function ({commit, state}, payload) {
        commit('SET_FIELDS_AUTOCOMPLETE_LOADING');

        return state.service.autocomplete(payload).then(response => {
            commit('SET_FIELDS_AUTOCOMPLETE', response.data);
            commit('SET_FIELDS_AUTOCOMPLETE_LOADING', false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit)
        })
    },
}
